export default {
  navtab: {
    login: 'Login',
    register: 'Register',
    memberCenter: 'Member Center',
    logout: 'Logout',
    BusinessCenter: 'Business Center',
    bindBank: 'Bind Bank Card',
    editInfo: 'Edit Information',
    store: 'Add Funds',
    withdraw: 'Withdraw Online',
    record: 'Transaction Details'
  },
  btn: {
    start: 'Start Management',
    startNow: 'Start Now',
    OverviewMore: 'Learn More',
    QuickOverview: 'Quick Overview',
    nowReg: 'Register Now',
    backInd: 'Back to Home',
    haveUsername: 'Already Have an Account',
    save: 'Save',
    settlement: 'Settlement',
    ProductSelection: 'Product Selection',
    SalesChannel: 'Sales Channel',
    editLogPwd: 'Change Login Password',
    editPayPwd: 'Change Withdrawal Password'
  },
  goodsCat: {
    beauty: 'Beauty',
    food: 'Food',
    necessary: 'Daily Necessities',
    ClothesShoes: 'Clothing & Shoes',
    Infants: 'Infants',
    Electrical: 'Electronics & 3C',
    SkinCare: 'Skincare',
    SmallThings: 'Creative Gadgets',
    other: 'Others',
    FB: 'Facebook',
    IG: 'Instagram',
    GOOGLE: 'Google',
    YOUTUBE: 'YouTube',
    LIVE: 'Live Commerce',
    TIKTOk: 'TikTok',
    OEM1: 'Charging Cable Packaging',
    OEM2: 'Colored Pencil Packaging',
    OEM3: 'Keychain Processing',
    OEM4: 'Number Packaging',
    OEM5: 'Eyebrow Trimmer Packaging',
    OEM6: 'Socks OEM',
    OEM7: 'Makeup Sponge Packaging',
    OEM8: 'Carton OEM',
    OEM9: 'Beading OEM',
    OEM10: 'Tag OEM',
    OEM11: 'Button Packaging',
    OEM12: 'Mask OEM',
    OEM13: 'Hair Tie Packaging',
    OEM14: 'Hair Tie OEM',
    OEM15: 'Hairpin Packaging',
    buyPop: 'Please upgrade to Gold Membership first!'
  },
  index: {
    bannerTip: 'Providing a professional, efficient, and secure e-commerce environment',
    bannerTitle: 'Sales | Channels | Profit',
    block2Title: 'Introduction',
    block2Tip1: 'A new fast e-commerce medium founded by advertising industry experts, our team connects top-quality products and channels daily.',
    block2Tip2: 'We build innovative platforms to create circulation benefits, enhance corporate liquidity, and shape the future of fast e-commerce. Our open platform integrates products, channels, clients, payment flows, advertising media, and sales personnel with smart digital services and big data marketing, making business operations seamlessly adapt to lifestyles.',
    block3Title: 'Core Advantages',
    block3Tip: 'Pioneering a new era to help members create wealth and deliver optimal products to clients',
    block3ItemTitle1: 'Cross-Device Compatibility',
    block3ItemTip1: 'Our interface works flawlessly on any device for easy browsing',
    block3ItemTitle2: 'Product Inspection',
    block3ItemTip2: 'Our interface works flawlessly on any device for easy browsing', // Note: Duplicate content, consider revising
    block3ItemTitle3: 'Rapid Sales Execution',
    block3ItemTip3: 'Sell selected products swiftly via advertising channels, prioritizing efficiency',
    block3ItemTitle4: 'Global Channels',
    block3ItemTip4: 'Utilize the most efficient internationalized tools to deeply engage clients and businesses',
    block4Title: 'Leading the E-commerce Industry',
    block4Tip: 'Leverage product and channel features to ensure quality, prioritize business selection, and protect stakeholders with big data and enterprise management platforms.',
    OverviewTitle: 'Explore Global Fast E-commerce Products',
    block5Title: 'Sponsors & Regulators',
    block5Tip: 'Building a new era to help you create and safeguard wealth',
    block5Item1: 'Consumer Foundation (ROC)',
    block5Item2: 'U.S. Consumer Product Safety Commission',
    block5Item3: 'Japan Consumer Affairs Agency',
    companyInfo: 'This platform protects users and clients. Risks are borne by the company. Unauthorized uses are not managed. Users must fully understand business principles and client agreements.'
  },
  logRes: {
    inUsername: 'Enter Account',
    inPwd: 'Enter Password',
    realName: 'Real Name',
    inRealName: 'Enter Real Name',
    phoneNum: 'Phone Number',
    inPhoneNum: 'e.g., 0987654321',
    phoneNumTip: 'To protect your rights, registered name/ID/account must belong to the same person. Use your own SMS-capable phone number. Creating multiple accounts with overlapping identities may result in penalties.',
    username: 'Username',
    inUser: '3-20 alphanumeric characters',
    reInpwd: 'Re-enter Password',
    softWare: 'Messaging App',
    inLine: 'Enter LINE ID',
    inChat: 'Enter WeChat ID',
    InCode: 'Enter Verification Code',
    checkTips: 'I confirm I am over 18 and all activities comply with my country’s laws. I accept all terms related to this application.',
    isCheck: 'Please confirm you are over 18',
    inputRealName: 'Please enter real name',
    inputPhone: 'Please enter phone number',
    inputPwd: 'Please enter password',
    inputRePwd: 'Please confirm password',
    inputAccount: 'Please enter username',
    inputLinkId: 'Please enter LINE ID',
    inputWechat: 'Please enter WeChat ID',
    difPwd: 'Passwords do not match. Please re-enter.',
    accountExist: 'Account already exists!',
    success: 'Success!'
  },
  edit: {
    title: 'Edit Information',
    logUsername: 'Login Account',
    name: 'Name',
    editPwd: 'Change Password',
    inOldEditPwd: 'Enter Old Password',
    inEditPwd: 'Enter New Password',
    rePwd: 'Confirm Password',
    inRePwd: 'Re-enter New Password',
    tipTitle: 'Notes:',
    tipTips: 'Contact customer service for changes due to force majeure.',
    PwdNoEmpty: 'New password cannot be empty',
    rePwdNoEmpty: 'Confirm password cannot be empty',
    OldPwdNoEmpty: 'Old password cannot be empty',
    editPayPwd: ''
  },
  member: {
    salesSurplus: 'Sales Surplus',
    TodayCustomers: "Today's Clients",
    growthRate: 'Client Growth Rate',
    salesGrowthRate: 'Revenue Growth Rate',
    newsTitle: 'Latest News',
    cateTitle: 'Sales Center, Channels, Sponsors',
    cateItem1: 'Product Selection & Global Channels',
    cateItem2: 'Vendor Deployment',
    proListTitle: 'Product Selection & Channels',
    proListCate1: 'Product Categories',
    proListCate2: 'Global Channels',
    proOEMTitle: 'Home OEM'
  },
  record: {
    closeTitle: 'Transaction Details',
    tab1: 'Purchase History',
    tab2: 'Withdrawal History',
    orderTime: 'Order Date',
    detail: 'Details',
    mount: 'Amount',
    project: 'Item',
    status: 'Status',
    Pending: 'Pending',
    reject: 'Rejected',
    Processed: 'Processed',
    ratio: 'Service Fee'
  },
  buy: {
    RechargeTarget: 'Top-Up Target',
    moneyTitle: 'Enter Amount',
    inMoney: 'Please enter amount',
    tipTitle: 'Important Notes',
    tipTip1: 'Accounts sharing IP/address/device may be suspended if deemed fraudulent.',
    tipTip2: 'Minimum top-up: 1000 points. Ensure correct account details; errors are your responsibility.',
    tipTip3: 'Account binding is permanent after initial setup.',
    tipTip4: 'Money laundering or fraud will result in account termination without notice.'
  },
  withdraw: {
    title: 'Online Withdrawal',
    accountCount: 'Account Balance',
    withdrawMount: 'Withdrawal Amount',
    withdrawPwd: 'Withdrawal Password',
    tipTip1: 'Accounts sharing IP/address/device may be suspended if deemed fraudulent.',
    tipTip2: 'Ensure correct account details; errors are your responsibility.',
    tipTip3: 'Account binding is permanent after initial setup.',
    tipTip4: 'Money laundering or fraud will result in account termination without notice.'
  },
  bank: {
    title: 'Bank Card Information',
    bankName: 'Bank Name',
    inBankName: 'Enter Bank Name',
    bankAddress: 'Branch Name',
    inBankAddress: 'Enter Branch Name',
    bankAccount: 'Bank Account',
    inBankAccount: 'Enter Bank Account',
    bankPassword: 'Transaction Password',
    inBankPassword: 'Enter Transaction Password'
  },
  product: {
    productList: 'Product List',
    sold: 'Sold',
    originalPrice: 'Original price',
    discount: 'Discount',
    nowPrice: 'Lowest price',
    detailed: 'Detailed',
    productDetails: 'Product Details',
    buyNow: 'Buy it now'
  }
}
